(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const syncThcFreeEdiblesVisibility = () => {
    const currentUrl = new URL(window.location.href);
    const onDefaultEdibles = currentUrl.pathname.replace(/\/$/, '') === '/collections/edibles'
      && !currentUrl.searchParams.has('filter.p.m.custom.thc_free');

    document.documentElement.classList.toggle('hide-thc-free-from-edibles', onDefaultEdibles);
  };

  const syncUnavailableEdiblesVisibility = () => {
    const currentUrl = new URL(window.location.href);
    const onEdibles = currentUrl.pathname.replace(/\/$/, '') === '/collections/edibles';

    document.documentElement.classList.toggle('hide-unavailable-from-edibles', onEdibles);
  };

  const syncUnavailableDrinksVisibility = () => {
    const currentUrl = new URL(window.location.href);
    const onDrinks = currentUrl.pathname.replace(/\/$/, '') === '/collections/drinks';

    document.documentElement.classList.toggle('hide-unavailable-from-drinks', onDrinks);
  };

  syncThcFreeEdiblesVisibility();
  syncUnavailableEdiblesVisibility();
  syncUnavailableDrinksVisibility();

  ['pushState', 'replaceState'].forEach((method) => {
    const originalMethod = history[method];
    history[method] = function (...args) {
      const result = originalMethod.apply(this, args);
      syncThcFreeEdiblesVisibility();
      syncUnavailableEdiblesVisibility();
      syncUnavailableDrinksVisibility();
      return result;
    };
  });

  window.addEventListener('popstate', () => {
    syncThcFreeEdiblesVisibility();
    syncUnavailableEdiblesVisibility();
    syncUnavailableDrinksVisibility();
  });

  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
